<template>
<div class="fc-page fc-page-refund"><header class="fc-child-heading"><h2>退费订单查询</h2><p>核对课程退费、剩余课时与实际退费金额</p></header>
 <section class="fc-filters" aria-label="退费订单查询筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>核对课程退费、剩余课时与实际退费金额</span></div><form @submit.prevent="queryClicked"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-text-field clearable dense label="订单ID" outlined v-model="query.id" color="#d9363e" hide-details aria-label="订单ID">
							</v-text-field></div>
<div class="fc-filter-cell"><v-text-field clearable dense label="学员姓名" outlined v-model="query.studentName" color="#d9363e" hide-details aria-label="学员姓名">
							</v-text-field></div>
<div class="fc-filter-cell"><v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
							    transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.start" label="开始日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" hide-details aria-label="开始日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.start"  @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu></div>
<div class="fc-filter-cell"><v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
								 transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.end" label="结束日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" hide-details aria-label="结束日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu></div></div><div class="fc-filter-bottom"><span>查询当前校区的记录</span><div class="fc-filter-actions"><v-btn type="submit" class="fc-query" depressed color="#d9363e" dark :loading="query.loading"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></div></form></section>
 <section class="fc-records" aria-label="课程退费记录"><div class="fc-list-heading"><h3>课程退费记录</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span><span class="fc-list-note">保留课程退费金额与操作记录</span></div>
 <v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table fc-table-refund" :mobile-breakpoint="0" disable-pagination hide-default-footer item-key="id" loading-text="正在加载，请稍候…" no-data-text="暂无符合条件的记录">
<template v-slot:item.studentName="{item}"><strong class="fc-student-name">{{item.studentName}}</strong></template>
<template v-slot:item.memo="{item}"><div class="fc-memo">{{item.memo}}</div></template>
<template v-slot:item.reduceHours="{item}"><span class="fc-number" :class="{'fc-negative':Number(item.reduceHours)<0}">{{item.reduceHours}}</span></template>
<template v-slot:item.reduceFee="{item}"><span class="fc-number" :class="{'fc-negative':Number(item.reduceFee)<0}">{{item.reduceFee}}</span></template>
<template v-slot:item.realRefundFee="{item}"><span class="fc-number" :class="{'fc-negative':Number(item.realRefundFee)<0}">{{item.realRefundFee}}</span></template></v-data-table>
 <div class="fc-pagination"><div class="fc-page-size"><span>每页</span><v-select :items="[10,20,50,100]" @change="handleSizeChange" dense hide-details aria-label="每页数量" outlined v-model="query.size" color="#d9363e" /><span>条</span><span class="fc-total">共 {{data.total}} 条记录</span></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange" :total-visible="5" v-model="query.page" color="#d9363e" /></div></section></div>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "course-refund-order-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				
				data: {
					total: 0,
					headers: [
						{
							text: '订单ID',
							value: 'id',
							sortable: false
						},
						{
							text: '时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '学员姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '课程名称',
							value: 'courseName',
							sortable: false
						},
						{
							text: '剩余课时',
							value: 'reduceHours',
							sortable: false
						},
						
						{
							text: '剩余金额',
							value: 'reduceFee',
							sortable: false
						},
						{
							text: '实际退费金额',
							value: 'realRefundFee',
							sortable: false
						},
						{
							text: '操作人',
							value: 'creatorName',
							sortable: false
						},
						{
							text: '备注',
							value: 'memo',
							sortable: false
						},
					],
					list: [],
				},
				query: {
					loading: false,
					page: 1,
					size: 20,
					id:"",
					start: "",
					end: "",
					studentName:""
				},
			}
		},
		created() {
			this.getTableDataList();
		},
		computed:{
			
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			
			getTableDataList() {
				const that = this;
				this.query.loading = true;

				const shopId = utils.getCurrentShopId();
				let url = `/financial/course/refund/order/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.id) {
					url += "&id=" + this.query.id;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.studentName) {
					url += "&studentName=" + this.query.studentName;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
</script>

<style lang="scss" scoped src="../../../assets/styles/course-account.scss"></style>
